import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type ResetPasswordV1UsersPasswordPutData,
  type ResetPasswordV1UsersPasswordPutError,
  type ResetPasswordV1UsersPasswordPutResponses,
  resetPasswordV1UsersPasswordPut,
} from '../../generated';

export type ResetPasswordMutationVariables = NonNullable<ResetPasswordV1UsersPasswordPutData['query']>;

export type ResetPasswordMutation =
  ResetPasswordV1UsersPasswordPutResponses[keyof ResetPasswordV1UsersPasswordPutResponses];

export const useResetPasswordMutation = <TError = ResetPasswordV1UsersPasswordPutError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>({
    mutationKey: ['ResetPassword'],
    mutationFn: async ({ email_address, status_code }: ResetPasswordMutationVariables) => {
      const { data } = await resetPasswordV1UsersPasswordPut({
        query: { email_address, status_code },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useResetPasswordMutation.fetcher = (
  { email_address, status_code }: ResetPasswordMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await resetPasswordV1UsersPasswordPut({
      query: { email_address, status_code },
      throwOnError: true,
    });
    return data;
  };
};
